import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatSnackBarModule,MatProgressSpinnerModule, MatPaginatorModule,MatProgressBarModule,
MatRadioModule, MatSidenavModule,MatCardModule,MatInputModule,MatOptionModule, MatSelectModule,
MatIconModule, MatDatepickerModule, MatNativeDateModule,MatChipsModule,MatSlideToggleModule,
MatButtonToggleModule,MatSliderModule,MatFormFieldModule,MatToolbarModule, MatListModule,
 MatButtonModule,MatTableModule,} from '@angular/material'
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTreeModule } from '@angular/material/tree';
import {MatMenuModule} from '@angular/material/menu';
import {MatTooltipModule} from '@angular/material/tooltip';
import {DragDropModule} from '@angular/cdk/drag-drop'
import { ngfModule } from 'angular-file';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MatSnackBarModule,MatProgressSpinnerModule,MatPaginatorModule,MatProgressBarModule,
    MatRadioModule, MatSidenavModule,MatCardModule,MatInputModule,MatOptionModule,
     MatSelectModule, MatIconModule,MatDatepickerModule, MatNativeDateModule,MatChipsModule,
     MatIconModule,MatAutocompleteModule,MatCheckboxModule,MatButtonToggleModule,
     MatFormFieldModule,MatSliderModule,MatSlideToggleModule, MatDividerModule,
     MatExpansionModule,MatGridListModule,MatStepperModule,MatTabsModule,MatTreeModule,
     MatMenuModule,MatToolbarModule,MatListModule,MatButtonModule,MatTableModule, 
     MatTooltipModule,DragDropModule,ngfModule
  ],
  exports: [
    MatSnackBarModule,MatProgressSpinnerModule,MatPaginatorModule,MatProgressBarModule,
    MatRadioModule, MatSidenavModule,MatCardModule,MatInputModule,MatOptionModule,
     MatSelectModule, MatIconModule,MatDatepickerModule, MatNativeDateModule,MatChipsModule,
     MatIconModule,MatAutocompleteModule,MatCheckboxModule,MatButtonToggleModule,
     MatFormFieldModule,MatSliderModule,MatSlideToggleModule, MatDividerModule,
     MatExpansionModule,MatGridListModule,MatStepperModule,MatTabsModule,MatTreeModule,
     MatMenuModule,MatToolbarModule,MatListModule,MatButtonModule,MatTableModule, 
     MatTooltipModule,DragDropModule,ngfModule
    
  ]
})
export class AppMaterialModule { }
